import Vue from 'vue';
import App from './App.vue';
import router from '@p/router'
import store from '@p/store';
import ElementUI from 'element-ui';
import i18n from '@/language';
import api from '@p/api';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css'
import 'element-ui/lib/theme-chalk/index.css';
import '@/common/css/common.css';
import '@p/assets/css/common.less';
import '@p/assets/font/iconfont.js';
import * as filters from '@/common/js/filters'
import skip from '@p/utils/skip.js'

const skipPath = new skip()
skipPath.renader()
skipPath.callappElement()

Vue.prototype.$http = api;

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

// 过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false;

NProgress.inc(0.2)
NProgress.configure({ ease: 'ease', speed: 500,showSpinner: false })

//路由拦截-进入页面前执行
router.beforeEach((to, from, next) => {
  //面包屑
  if(to.name!=='homePage'){
    const breadcrumb={
      path:to.path,
      query:to.query,
    }
    store.commit('setBreadcrumb',breadcrumb)
  }else{
    store.commit('setBreadcrumb','')
  }
  const userMessage=localStorage.getItem('token');
  NProgress.start() //进度条
  if(!userMessage && to.path!=='/login'){
    next({path:'/login',query:{path:to.query.id ? to.query.id :'', title: to.query.title ? to.query.title :''}});
  }else{
    next();
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  }
})

router.afterEach(transition => {
  NProgress.done()
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
